import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getTrailerPlayback, getClientThumbnails } from "@/services/hls.client";
import type { TrailerPlayQueryParams, ThumbnailsQueryParams, ThumbnailItem } from "@/types/hls";
export const fetchTrailerPlayback = async ({
  trailerUuid
}: TrailerPlayQueryParams) => {
  return getTrailerPlayback(trailerUuid);
};
export function useThumbnails(params) {
  const $ = _c(10);
  const t0 = params?.content_uuid;
  const t1 = params?.entity_type;
  const t2 = params?.entity_uuid;
  let t3;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2) {
    t3 = ["thumbnails", t0, t1, t2];
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== params) {
    t4 = () => getClientThumbnails(params);
    $[4] = params;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !!params?.content_uuid && !!params?.entity_uuid;
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5,
      staleTime: 600000,
      gcTime: 1800000
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return useQuery(t6);
}